import { useAuthenticationStore } from "@/stores/authentication"
import { useEstablishmentStore } from "@/stores/establishment"
import { getAccessContract } from "@/utils/contract"

/**
 * Aligné avec la logique de hasReviewMenuItem dans Menu.vue :
 * l'utilisateur doit avoir la feature REVIEW et le plan du contrat doit l'inclure
 */
export default () => {
  const auth = useAuthenticationStore()
  const establishmentStore = useEstablishmentStore()

  const userHasFeature =
    auth.user?.access_features?.find((feature) => feature.code === "REVIEW") !== undefined
  if (!userHasFeature) {
    return { success: false, path: "/error" }
  }

  const productPlan = getAccessContract(establishmentStore.currentEstablishment)?.product_plan
  const planHasFeature =
    productPlan?.access_features?.find((feature: { code: string }) => feature.code === "REVIEW") !== undefined
  if (!planHasFeature) {
    return { success: false, path: "/error" }
  }

  return { success: true }
}
